module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-landing"
  }, [_c('video-modal', {
    attrs: {
      "open": _vm.videoModalOpen
    },
    on: {
      "close": _vm.closeModal
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 white text-center text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0"
  }, [_vm._v("Tired of filling out the same frustrating forms over and over again?")]), _vm._v(" "), _c('div', {
    staticClass: "m-y"
  }, [_c('a', {
    attrs: {
      "id": "openVideoModal"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/patient/play-icon.png")
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-lg"
  }, [_c('app-links', {
    attrs: {
      "appLinks": _vm.links
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content text-center"
  }, [_c('h2', {
    staticClass: "m-t-0"
  }, [_vm._v("Patients")]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign up for free")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content text-center"
  }, [_c('h2', {
    staticClass: "m-t-0"
  }, [_vm._v("Healthcare Professionals")]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.navAndSetContext('practice')
      }
    }
  }, [_vm._v("Practice")]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.navAndSetContext('academic')
      }
    }
  }, [_vm._v("Academic")])])])])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/patient/2.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v("No More"), _c('br'), _vm._v("Paper Forms")]), _vm._v(" "), _c('p', [_vm._v("Complete electronically before you arrive")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/patient/3.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Capture Your"), _c('br'), _vm._v("Details Once")]), _vm._v(" "), _c('p', [_vm._v("And you’ll never need to do it again")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/patient/4.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Your Information Is"), _c('br'), _vm._v("Secure")]), _vm._v(" "), _c('p', [_vm._v("You choose who has access to your information")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/patient/share-with-practice.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {}, [_vm._v("Patient Benefits")]), _vm._v(" "), _c('p', {
    staticClass: "lead m-b-lg"
  }, [_vm._v("Frustrated with filling out the same medical forms over and over again? Simplify your medical life with LogBox.")]), _vm._v(" "), _c('ul', {
    staticClass: "feature-list fa-ul"
  }, [_c('li', {
    staticClass: "hidden"
  }, [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Stop filling out the same medical forms over and over again. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Free for patients. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Keep your information secure on a mobile app or website. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Share your information with any healthcare professional you choose.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("LogBox works regardless of your medical aid. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Stay in control of your information, you decide who sees it and when.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Your information is secured according to the highest international standards.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section bg-primary"
  }, [_vm._m(1)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign Up Now")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328bb3fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brochure/Patient.vue
// module id = 652
// module chunks = 5